import React, { useState, useEffect } from "react";
import { View, ScrollView, Text, Dimensions, Platform } from "react-native";
import { StyleSheet } from "react-native";
import {
  ImageComponent,
  InfoComponent,
  Cronometro,
  SCREEN_IDS,
} from "../components/FullComponent.js";
import { LinearGradient } from "expo-linear-gradient";
import { useFocusEffect } from "@react-navigation/native";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { parseDurationToMinutes } from "../services/Functions.js";
import { getListProblemSolution } from "../services/ConnectDataBase.js";
import CleanIncident from "../components/Common/ComponentCleanIncident.js";
import { backgroundColor, backgroundColor2 } from "../constants/Constants.js";
import { PROBLEM_QUALITY_SCREEN_COLORS } from "../style/colors.js";
import { notify } from "../services/ui/notify";

const { width } = Dimensions.get("window");

export default function ProblemQualityScreen({ navigation }) {
  const dispatch = useDispatch();
  const infoData = useSelector((state) => state.infoData.infoData);
  const isTimerRunning = useSelector((state) => state.timer.isTimerRunning);
  const cod_team = useSelector((state) => state.user.cod_team);
  const equipo = useSelector((state) => state.user.team);
  const { tiempos, ...data } = infoData;
  const [listOption, setListOption] = useState([]);
  const [ArrayDataTimeModified, setArrayDataTimeModified] = useState([]);

  const currentScreenId = SCREEN_IDS.PROBLEM_QUALITY;

  useFocusEffect(
    React.useCallback(() => {
      const handleBackButton = () => {
        if (isTimerRunning) {
          notify.warn(
            "¡Atención! El contador está en funcionamiento. Por favor, detén el contador antes de salir."
          );
          return true;
        }
        return false;
      };

      const unsubscribe = navigation.addListener("beforeRemove", (e) => {
        if (isTimerRunning) {
          e.preventDefault();
          handleBackButton();
        }
      });

      return () => {
        unsubscribe();
      };
    }, [isTimerRunning])
  );

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isTimerRunning) {
        event.preventDefault();
        event.returnValue =
          "¡Atención! El contador está en funcionamiento. Por favor, detén el contador antes de salir.";
      }
    };

    if (Platform.OS === "web") {
      window.addEventListener("beforeunload", handleBeforeUnload);

      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    }
  }, [isTimerRunning]);

  useEffect(() => {
    getListOptionsProblemQuality();
  }, []);

  async function getListOptionsProblemQuality() {
    try {
      const options = await getListProblemSolution(
        infoData.MO,
        5,
        cod_team,
        "list"
      );
      setListOption(options);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    if (listOption && tiempos) {
      const modifiedTimes = tiempos
        .filter(
          ({ incidencia }) =>
            typeof incidencia === "string" && incidencia !== ""
        )
        .map(
          ({
            usuario,
            team,
            fecha_ini,
            fecha_fin,
            incidencia,
            duracion,
            cantidad_incidencia,
          }) => {
            const matchingOption = listOption.find(
              (option) => option.incidencia === incidencia
            );
            const descind = matchingOption ? matchingOption.descind : "";
            const descsol = matchingOption ? matchingOption.descsol : "";

            const StartDate = moment(fecha_ini?.date);
            const EndDate = moment(fecha_fin?.date);

            const formattedStartDate = StartDate.isValid()
              ? StartDate.format("DD/MM/YY HH:mm")
              : "-";
            const formattedEndDate = EndDate.isValid()
              ? EndDate.format("DD/MM/YY HH:mm")
              : "-";
            const formattedDuration = duracion?.date
              ? moment(duracion.date).format("HH:mm:ss")
              : "-";

            return {
              usuario: usuario || "",
              equipo: team || "",
              Problema: descind || "-",
              Solución: descsol || "-",
              inicio: formattedStartDate || "-",
              fin: formattedEndDate || "-",
              duracion: formattedDuration || "-",
              cantidad_incidencia: cantidad_incidencia
                ? Number(cantidad_incidencia).toFixed(1)
                : "-",
            };
          }
        );

      const sortedArrayDataTime = modifiedTimes.sort((a, b) => {
        const dateA = moment(a.fin, "DD/MM/YY HH:mm");
        const dateB = moment(b.fin, "DD/MM/YY HH:mm");

        return dateB.diff(dateA);
      });

      setArrayDataTimeModified(sortedArrayDataTime);
    }
  }, [listOption, tiempos]);

  const TableComponent = () => {
    return (
      <View style={{ flex: 1 }}>
        <View style={styles.header}>
          <Text style={styles.headerCell}>Operario</Text>
          <Text style={styles.headerCell}>Equipo</Text>
          <Text style={styles.headerCell}>Problema</Text>
          <Text style={styles.headerCell}>Solución</Text>
          <Text style={styles.headerCell}>Inicio</Text>
          <Text style={styles.headerCell}>Fin</Text>
          <Text style={styles.headerCell}>Min. Real</Text>
          <Text style={styles.headerCell}>Unidades</Text>
        </View>
        <ScrollView style={styles.dataContainer}>
          {ArrayDataTimeModified.map((item, index) => (
            <View key={index} style={styles.row}>
              <Text style={styles.cell}>{item.usuario}</Text>
              <Text style={styles.cell}>{item.equipo}</Text>
              <Text style={styles.cell}>{item.Problema}</Text>
              <Text style={styles.cell}>{item.Solución}</Text>
              <Text style={styles.cell}>{item.inicio}</Text>
              <Text style={styles.cell}>{item.fin}</Text>
              <Text style={styles.cell}>
                {parseDurationToMinutes(item.duracion)
                  ? parseDurationToMinutes(item.duracion).toFixed(2)
                  : "-"}
              </Text>
              <Text style={styles.cell}>{item.cantidad_incidencia}</Text>
            </View>
          ))}
        </ScrollView>
      </View>
    );
  };

  return (
    <LinearGradient
      colors={backgroundColor()}
      style={styles.backgrounOptionDos}>
      <ScrollView style={styles.backgrounOptionDos}>
        <View style={[styles.container, { padding: 15 }]}>
          <View style={styles.row}>
            <View style={[styles.column, { flex: 1 }]}>
              <InfoComponent data={data} />
            </View>
            <View style={[styles.column, { marginLeft: 20, flex: 1 }]}>
              <ImageComponent data={data} />
            </View>
          </View>

          <View style={{ flexDirection: "row" }}>
            <Cronometro
              screen={currentScreenId}
              listData={data.eFabrica}
              po={data.PO}
              mo={data.MO}
            />
          </View>

          {equipo === "Control de calidad" && <CleanIncident />}

          <View style={{ height: "50vh" }}>
            <TableComponent />
          </View>
        </View>
      </ScrollView>
    </LinearGradient>
  );
}

const styles = StyleSheet.create({
     header: {
     flexDirection: "row",
     borderBottomWidth: 1,
     borderBottomColor: PROBLEM_QUALITY_SCREEN_COLORS.BORDER_LIGHT,
     paddingVertical: 10,
     backgroundColor: PROBLEM_QUALITY_SCREEN_COLORS.BACKGROUND_BUTTON_PRIMARY,
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1,
  },
  headerCell: {
    flex: 1,
    fontWeight: "bold",
    textAlign: "center",
    color: "white",
  },
  dataContainer: {
    flex: 1,
    marginTop: 50,
    backgroundColor: backgroundColor2,
  },
     row: {
     flexDirection: "row",
     borderBottomWidth: 1,
     borderBottomColor: PROBLEM_QUALITY_SCREEN_COLORS.BORDER_LIGHT,
     paddingVertical: 10,
   },
  cell: {
    flex: 1,
    textAlign: "center",
    fontFamily: "monospace",
    color: "white",
  },
  icon: {
    textAlign: "center",
  },
  backgrounOptionDos: {
    flex: 1,
  },
  container: {
    flex: 1,
  },
  column: {
    flexDirection: "column",
  },
});
